const swiper = new Swiper('.js-slide', {
	centeredSlides: true,
	slidesPerView: 1.35,
	spaceBetween: 22,
	loop: true,
	loopAdditionalSlides: 1,
	speed: 1200,
	autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		768: {
			allowTouchMove: false,
			slidesPerView: 1,
			spaceBetween: 95,
		}
	}
});

function fixedItemHome() {
	const $fixedItem = $('.js-fixed-item');

	$(window).on('scroll', () => {
		const $trigger = $('.js-trigger').offset().top;
		const scrollTop = $(window).scrollTop();
		const scrollPosition = window.innerHeight + scrollTop;
		const footHeight = $('.l-footer').offset().top;

		if(scrollTop >= $trigger) {
			$fixedItem.addClass('is-fixed');
			$fixedItem.removeClass('is-fixed-close');
		} else {
			if($fixedItem.hasClass('is-fixed')) {
				$fixedItem.removeClass('is-fixed');
				$fixedItem.addClass('is-fixed-close');
			}
		}

		if(scrollPosition >= footHeight) {
			$fixedItem.removeClass('is-fixed');
			$fixedItem.addClass('is-fixed-close');
		}
	});
}

window.addEventListener('load' , () =>  {
	$('.page-home-slide__abs').addClass('is-ready');
	$('.page-home-slide__body').addClass('is-ready');
	$('.page-home-slide__img').addClass('is-ready');

	fixedItemHome();
});
